// src/js/config/flexView.js

/**
 * Initierar Flex-vyn genom att läsa offert-data och fylla i/låsa formulärfält.
 */
export function initializeFlexView() {
    // Läs in datan som PHP har placerat på sidan
    const quoteData = window.SimP_Quote_Data;

    // Om ingen offert-data finns, avbryt.
    if (!quoteData || typeof quoteData !== 'object') {
        console.warn('Flex View Initializer: Offertdata (SimP_Quote_Data) saknas eller är i fel format.');
        return;
    }

    // En hjälpfunktion för att fylla i och låsa ett fält
    function populateAndLock(inputElement, value) {
        if (inputElement && value && parseFloat(value) > 0) {
            inputElement.value = value;
            inputElement.disabled = true;

            // Dölj även +/- knapparna för det låsta fältet
            const buttonContainer = inputElement.closest('td').querySelector('.button-container');
            if (buttonContainer) {
                buttonContainer.style.display = 'none';
            }
        }
    }

    // Loopa igenom all offert-data och applicera den på formuläret
    for (const featureId in quoteData) {
        if (Object.prototype.hasOwnProperty.call(quoteData, featureId)) {
            const value = quoteData[featureId];

            // Hitta motsvarande input-fält med det dynamiska featureId
            const inputElement = document.querySelector(`tr[data-feature-id="${featureId}"] input[type="number"]`);

            if(inputElement) {
                populateAndLock(inputElement, value);
            } else {
                console.warn(`Flex View Initializer: Kunde inte hitta ett input-fält för feature_id "${featureId}".`);
            }
        }
    }
    console.log('Flex View Initialized.');
}